// src/firebase/client.js
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

// ✅ Use your POS project's firebaseConfig here
const firebaseConfig = {
  apiKey: "AIzaSyDjSqHj42duuyG77akomHZ1g1DkMHDOl-8",
  authDomain: "pos2025-3fa86.firebaseapp.com",
  databaseURL: "https://pos2025-3fa86-default-rtdb.firebaseio.com",
  projectId: "pos2025-3fa86",
  storageBucket: "pos2025-3fa86.firebasestorage.app",
  messagingSenderId: "359342921802",
  appId: "1:359342921802:web:c5268e5104e5b628856eb3",
  measurementId: "G-DMZJZ0DCZ4"
};

const app = initializeApp(firebaseConfig);
export const db = getDatabase(app);
